import { Crown } from "frontend/icons/crown";
import style from "./responsive-template-card-new.module.css";
import cn from "classnames";
import { CanvasTemplateMinimal } from "shared/datamodel/schemas/canvas-template";

export enum TemplateCardStyle {
  small = "small",
  regular = "regular",
}

export function ResponsiveTemplateCardNew({
  template,
  previewAvailable,
  onClick,
  onPreview,
  cardStyle,
}: {
  template: CanvasTemplateMinimal;
  previewAvailable: boolean;
  onClick: (template: CanvasTemplateMinimal) => void;
  onPreview: (template: CanvasTemplateMinimal) => void;
  cardStyle?: TemplateCardStyle;
}) {
  const isSmall = cardStyle === TemplateCardStyle.small;

  const name = template.name;

  return (
    <div
      className={cn(style.gridContainer, { [style.small]: isSmall })}
      data-testid={template.name}
      onClick={() => onClick(template)}
    >
      <div
        className={cn(style.templateImage, { [style.small]: isSmall })}
        data-testid={`${template.name}-responsive-template-image`}
      >
        <div className={style.imageContainer}>
          {template.thumbnailImageURL && <img src={template.thumbnailImageURL} alt={""} />}
        </div>
        {previewAvailable && (
          <div className={style.buttons}>
            <button className={style.useTemplateButton}>Use Template</button>
            <button
              className={style.previewButton}
              onClick={(event) => {
                event.stopPropagation();
                onPreview(template);
              }}
            >
              Preview
            </button>
          </div>
        )}
      </div>
      <div className={style.titleContainer}>
        <div className={style.templateTitle}>{name}</div>
        {template.upgradeRequired && (
          <div className={style.proBadge}>
            <Crown size={14} />
          </div>
        )}
      </div>
    </div>
  );
}
